enum InboundHoaInvoiceType {
  PurchaseInvoice = 'PurchaseInvoice',
  CreditNote = 'CreditNote',
  Draft = 'Draft',
  DraftPurchaseInvoice = 'DraftPurchaseInvoice',
  DraftCreditNote = 'DraftCreditNote',
}

export default InboundHoaInvoiceType;
